export default class SuccessStorySlider {

  slideEl = document.querySelectorAll('.success-story-slider .success-story-slider__slide');
  sliderInitialize = false;

  constructor() {
      this.addEvents();
  }

    addEvents() {
      const that = this;

      if (this.slideEl.length > 0) {

          window.addEventListener('load', e => {
              that.slideEl.forEach((el) => {
                  const youtube = el.querySelector('.youtube-link');

                  if (youtube) {
                      youtube.addEventListener('click', () => {
                          const youtubeLink = youtube.getAttribute('data-youtube') ? this.youtube_parser(youtube.getAttribute('data-youtube')) : '';
                          const popup = document.querySelector('.success-popup');
                          if (youtubeLink) {
                              const iframe = document.createElement("iframe");
                              iframe.src = 'https://www.youtube.com/embed/' + youtubeLink + '?rel=0&autoplay=1';
                              iframe.setAttribute('allowfullscreen', 'allowfullscreen');
                              popup.querySelector('.success-popup__iframe').appendChild(iframe);
                              popup.classList.add('active');
                              setTimeout(()=>{
                                  $('.success-popup__iframe iframe').css('z-index', '11');
                              }, 1000)
                          }
                      });
                  }
              });
              if(document.body.offsetWidth > 992){
                  that.sliderRemoveAttr();
              }
          });

          window.addEventListener('resize', e => {
              that.resize();
          });


          document.querySelector('.success-story-slider__next').addEventListener('click', function (event) {
              event.preventDefault();
              that.sliderRight();
          });

          document.querySelector('.success-story-slider__prev').addEventListener('click', function (event) {
              event.preventDefault();
              that.sliderLeft();
          });

          document.querySelectorAll('.success-story-slider__dots div').forEach(function (dot) {
              dot.addEventListener('click', function (event) {
                  event.preventDefault();
                  let current = Array.from(dot.parentNode.children).indexOf(dot);
                  that.sliderTo(current, current + 1);
              });
          });


          document.querySelectorAll('.success-popup .rgba, .success-popup__exit').forEach((element) => {
              element.addEventListener('click', () => {
                  const popup = document.querySelector('.success-popup');
                  popup.classList.remove('active');
                  popup.querySelector('iframe').remove();
              })
          });

          $('.success-story-slider__wrapper').swipe({
              swipeStatus: (event, phase, direction, distance, duration, fingerCount, fingerData, currentDirection) => {
                  if (phase == 'end') {
                      if (direction === 'up' || direction === 'down') return false;
                      if (direction == 'left')  that.sliderRight();;
                      if (direction == 'right') that.sliderLeft();;
                  }
              },
              triggerOnTouchEnd: false,
              allowPageScroll: 'vertical',
              threshold: 60
          });
      }
    }

    sliderLeft(){
        let current = parseInt(document.querySelector('.success-story-slider__wrapper').getAttribute('data-count'));
        if(current !== 0){
            this.sliderTo(current - 1, current);
        }

    }

    sliderRight(){
        this.sliderRemoveAttr();
        let current = parseInt(document.querySelector('.success-story-slider__wrapper').getAttribute('data-count'));
        if(current !== this.slideEl.length - 1){
            this.sliderTo(current+1, current + 2);
        }
    }

    sliderTo(number, active) {
        let element = this.slideEl[0];
        let widthElement = parseInt(window.getComputedStyle(element).width);
        let sliderWrapper = document.querySelector('.success-story-slider__wrapper');
        let sliderPrev = document.querySelector('.success-story-slider__prev');
        let sliderNext = document.querySelector('.success-story-slider__next');
        let sliderSlides = document.querySelectorAll('.success-story-slider__slide');
        let sliderDots = document.querySelectorAll('.success-story-slider__dots div');

        if (number === 0) {
            sliderPrev.classList.add('no-active');
            sliderNext.classList.remove('no-active');
        } else if (number === sliderSlides.length - 1) {
            sliderNext.classList.add('no-active');
            sliderPrev.classList.remove('no-active');
        } else {
            sliderNext.classList.remove('no-active');
            sliderPrev.classList.remove('no-active');
        }

        sliderWrapper.setAttribute('data-count', number);
        sliderWrapper.setAttribute('style', 'transform: translateX(-' + widthElement * number + 'px)');

        sliderSlides.forEach(function (slide) {
            slide.classList.remove('slide-active');
        });

        sliderSlides[active - 1].classList.add('slide-active');

        sliderDots.forEach(function (dot) {
            dot.classList.remove('active');
        });

        sliderDots[active - 1].classList.add('active');
    }

    resize() {
        let current = parseInt(document.querySelector('.success-story-slider__wrapper').getAttribute('data-count'));
        this.sliderTo(current, current + 1);
    }

    sliderRemoveAttr(){
        if (this.slideEl.length > 0 && !this.sliderInitialize) {
            this.slideEl.forEach((el) => {
                const data_image = el.querySelector('.success-story-slider__image img').getAttribute('data-src');
                const data_logo = el.querySelector('.success-story-slider__logo img').getAttribute('data-src');
                if (data_image) {
                    el.querySelector('.success-story-slider__image img').setAttribute('src', data_image);
                    el.querySelector('.success-story-slider__image img').removeAttribute('data-src');
                    el.querySelector('.success-story-slider__logo img').setAttribute('src', data_logo);
                    el.querySelector('.success-story-slider__logo img').removeAttribute('data-src');
                }
            })
            this.sliderInitialize = true;
        }
    }

  youtube_parser(url){
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    var match = url.match(regExp);
    return (match&&match[7].length==11)? match[7] : false;
  }




}
